import { render, staticRenderFns } from "./plot_points.vue?vue&type=template&id=4e70714a&scoped=true&"
import script from "./plot_points.vue?vue&type=script&lang=js&"
export * from "./plot_points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e70714a",
  null
  
)

export default component.exports